// Utility functions for the WebIdeal application

export const createPageUrl = (pageName) => {
  // Simple routing - you can enhance this based on your needs
  const routes = {
    Home: '/',
    About: '/about',
    Contact: '/contact',
    Products: '/products',
    ProductJobs: '/products/jobs',
    ProductRecruit: '/products/recruit',
    ProductATS: '/products/ats',
    ProductHRMS: '/products/hrms',
    Pricing: '/pricing',
    Blog: '/blog',
    Careers: '/careers',
    Resources: '/resources',
    Integrations: '/integrations',
    AIAutomation: '/ai-automation',
    Testimonials: '/testimonials',
    WhyWebIdeal: '/why-webideal',
    FAQ: '/faq',
    Privacy: '/privacy',
    Terms: '/terms',
    Admin: '/admin',
    // HRMS Site routes
    Dashboard: '/hrms/dashboard',
    Employees: '/hrms/employees',
    Attendance: '/hrms/attendance',
    Leave: '/hrms/leave',
    Payroll: '/hrms/payroll',
    Performance: '/hrms/performance',
    Recruitment: '/hrms/recruitment',
    Documents: '/hrms/documents',
    AIAssistant: '/hrms/ai-assistant'
  };
  
  return routes[pageName] || '/';
};